import { useContext, useEffect, useState } from 'react'
import { ArrowRight, Search, Star } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { companyApi } from '../../api/company'
import { contentApi } from '../../api/content-api'
import { homeApi } from '../../api/home-api'
import { userApi } from '../../api/user-api'
import BottomBar from '../../components/bottomBar'
import { imageConfig } from '../../config/config'
import { LoginContext, LoginMsgContext, WSContext } from '../../router/router'
import { localClear } from '../../utils/local-util'
import CoinList from './components/coinList'
import HomePopup from './components/homepopup'
import Noice from './components/noice'
import Optionbox from './components/optionbox'
import Optionbox2 from './components/optionbox2'
import Optionbox3 from './components/optionbox3'
import Swipper from './components/swipper'
import Zixunlist from './components/zixunlist'
import './index.css'
import Navbar from './componentsV1/navBar'
import GuideSection from './componentsV1/guideSection'
import CryptoList from './componentsV1/cryptoList'
import DepositSection from './componentsV1/depositSection'
import StatsSection from './componentsV1/statsSection'
import FeaturesSection from './componentsV1/featuresSection'
import RecurringBuySection from './componentsV1/recurringBuySection'
import UserTypesSection from './componentsV1/userTypesSection'
import ProModeSection from './componentsV1/proModeSection'
import Footer from './componentsV1/footer'

export default function HomeCenter() {
  const [content, setContent] = useState({} as any)
  const [companyData, setCompanyData] = useState(null as any)
  const [coinListData, setCoinListData] = useContext(WSContext)
  const [loginmsg, setloginmsg] = useContext(LoginMsgContext)
  const [login, _] = useContext(LoginContext)
  const [isShowHomePop, setIShowHomePop] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const [index, setindex] = useState(1)
  const [ctmarketlist, setCtmarketlist] = useState([] as any[])

  const loadUserInfoData = async () => {
    try {
      const data = await userApi.userInfo()
      if (data?.ok && data?.data) {
        setUserInfo(data.data)
      }
    } catch (error) {
      console.error('Failed to load user info:', error)
      // 可以添加错误提示
    }
  }

  const loadContentList = async () => {
    try {
      const data = await contentApi.list({ pageNum: 1, pageSize: 1 })
      if (data?.ok && data?.data?.records?.length > 0) {
        setContent(data.data.records[0])
      }
    } catch (error) {
      console.error('Failed to load content:', error)
    }
  }

  const loadctmarketlistData = async () => {
    const data = await homeApi.ctmarketlist({ pageNum: 1, pageSize: 100 })
    if (data.ok) {
      const list = data.data.records
      list.sort((d, e) => d.sort - e.sort)
      setCtmarketlist(list)
    }
  }

  //初始化获取公司
  async function initCompany() {
    const res = await companyApi.domain()
    if (res.ok) {
      setCompanyData(res.data)
    }
  }
  useEffect(() => {}, [])
  useEffect(() => {}, [])

  const navigate = useNavigate()
  return (
    <>
      <div className='max-w-6xl mx-auto'>
        <Navbar />
        <GuideSection />
        <div className='flex flex-col gap-y-20'>
          <CryptoList />
          <DepositSection />
          <StatsSection />
          <FeaturesSection />
          <RecurringBuySection />
          <UserTypesSection />
        </div>
      </div>
      <ProModeSection />
      <Footer />
    </>
  )
}
